module.exports = __webpack_public_path__ + "static/sponsorship_img-03-b@2x-4fb638e490a4990d4c0692b54909cda7.jpg";